import { Tooltip, withStyles } from '@material-ui/core';

const tooltipBorderColor = '#148192';

export const AdministrationUserDisableUserRole = withStyles(theme => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.text.primary,
    fontSize: '1em',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: tooltipBorderColor,
    borderRadius: '4px',
    width: '410px',
    maxWidth: '420px',
    padding: '10px',
    '& p': {
      padding: '0px',
      margin: '0px',
      marginLeft: '20px',
    },
    '& p:first-child': {
      fontWeight: '900',
    },
  },
  arrow: {
    color: theme.palette.common.white,
    '&:before': {
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: tooltipBorderColor,
    },
  },
}))(Tooltip);
